import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@fluentui/react-northstar';

const UsersFullNameText = (props) => {

    const { size, weight, content } = props;

    return (
      <Text
        data-testid="usersFullNameText"
        className="users-full-name-text"
        content={content}
        size={size}
        weight={weight}
      />
    );
};

UsersFullNameText.propTypes = {
    size: PropTypes.string,
    weight: PropTypes.string,
    content: PropTypes.string,
};

UsersFullNameText.defaultProps = {
    size: 'medium',
    weight: 'semibold',
}

export default UsersFullNameText;